<template>
  <div>
      <v-layout
        row wrap
      >
        <v-flex
            sm12
            class="hidden-md-and-up"
        >
            <v-toolbar
                flat
                style="background:transparent;border-bottom: 1px solid rgba(26,26,26,0.1);margin-bottom:10px;"
            >
                <v-btn
                    fab
                    flat
                    @click="drawer = true"
                >
                    <v-icon>
                        menu
                    </v-icon>
                </v-btn>
                <h2>Organization Settings</h2>
                <v-spacer />
            </v-toolbar>
        </v-flex>
        <v-flex
            sm12
            md3
            lg2
        >
            <v-navigation-drawer
                v-model="drawer"
                :permanent="$vuetify.breakpoint.mdAndUp"
                :temporary="$vuetify.breakpoint.smAndDown"
                :absolute="$vuetify.breakpoint.smAndDown"
                style="background:#fafafa;"
            >
                <v-toolbar
                    flat
                    style="background:transparent"
                >
                    <v-list
                        two-line
                    >
                        <v-list-tile>
                            <v-list-tile-title
                                class="title"
                            >
                                Settings
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>

                <v-list
                    v-for="sub in menu"
                    :key="sub.title"
                >
                    <v-subheader>{{sub.title}}</v-subheader>
                    <v-list-tile
                        v-for="key in sub.options"
                        active-class="router-active"
                        class="router-tile"
                        :key="key.title"
                        :to="{name: key.route}"
                    >
                        <v-list-tile-action>
                            <v-icon>{{key.icon}}</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{key.title}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex
            sm12
            md9
            lg10
            :class="{ padLeft: $vuetify.breakpoint.mdAndUp }"
        >
            <router-view></router-view>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
export default {
    data () {
        return {
            menu: [
                {
                    title: 'General',
                    options: [
                        {
                            title: 'Branding',
                            icon: 'mdi-palette',
                            route: 'OrgBranding'
                        },
                        {
                            title: 'Users',
                            icon: 'mdi-account-group',
                            route: 'OrgUsers'
                        },
                        {
                            title: 'Security Groups',
                            icon: 'mdi-security',
                            route: 'OrgGroups'
                        },
                        {
                            title: 'Roles',
                            icon: 'mdi-account-key',
                            route: 'OrgRoles'
                        }
                    ]
                },
                {
                    title: 'Communication',
                    options: [
                        {
                            title: 'News',
                            icon: 'mdi-newspaper',
                            route: 'OrgNews'
                        },
                        {
                            title: 'Support & Defaults',
                            icon: 'mdi-message-question',
                            route: 'OrgCommunicationDefaults'
                        },
                        {
                            title: 'Information Headers',
                            icon: 'mdi-sign-text',
                            route: 'OrgContactInfo'
                        },
                        {
                            title: 'Auto Reply',
                            icon: 'mdi-reply',
                            route: 'OrgCommunicationAutoReply'
                        },
                        {
                            title: 'Email Problems',
                            icon: 'mdi-email-alert',
                            route: 'OrgEmailBounces'
                        }
                    ]
                },
                {
                    title: 'Template Builder',
                    options: [
                        {
                            title: 'Fieldtypes',
                            icon: 'mdi-card-text',
                            route: 'OrgFieldtype'
                        }
                    ]
                },
                {
                    title: 'Cases',
                    options: [
                        {
                            title: 'Case Types',
                            icon: 'mdi-briefcase',
                            route: 'OrgCaseType'
                        }
                    ]
                },
                {
                    title: 'Webhooks',
                    options: [
                        {
                            title: 'Webhooks',
                            icon: 'mdi-webhook',
                            route: 'OrgWebhooks'
                        }
                    ]
                }
            ],
            drawer: false
        }
    },
    computed: {
        breakpoint () {
            return this.$vuetify.breakpoint
        }
    },
    watch: {
        breakpoint () {
            if (this.breakpoint.sm || this.breakpoint.xs) {
                this.drawer = false
            }
        }
    }
}
</script>

<style>
    .padLeft {
        padding-left: 25px;
    }

    .router-active {
        background: rgba(0,0,0,0.05);
        color: #1976d2 !important;
    }

</style>